import { FiltererOptions, SorterOptions } from '../constants';
import getStatusUpdate from '../utils/getStatusUpdate';
import getVersionDetails from '../utils/getVersionDetails';
import useActivitiesQueries from './useActivitiesQueries';
import useFilters from './useFilters';
function getActivityDate(activity) {
    if ('datetime' in activity && activity.datetime) {
        return new Date(activity.datetime).getTime();
    }
    if ('createdAt' in activity && activity.createdAt) {
        return new Date(activity.createdAt).getTime();
    }
    // Use current date as fallback to avoid grouping issues
    console.warn('Activity missing datetime and createdAt fields:', activity);
    return new Date().getTime();
}
function isNoteActivity(activity) {
    return 'notes' in activity;
}
function validToShowActivity(activity) {
    return isNoteActivity(activity) || getVersionDetails(activity).length > 0 || !!getStatusUpdate(activity);
}
export default function useActivities({ buildingId, inspectionId, workOrderId, deficiencyId }) {
    var _a;
    const { data: filtersData } = useFilters();
    const { activities, isLoading, hasMore, fetchMore } = useActivitiesQueries({
        buildingId,
        inspectionId,
        workOrderId,
        deficiencyId,
        params: {
            type: (filtersData === null || filtersData === void 0 ? void 0 : filtersData.filters) && (filtersData === null || filtersData === void 0 ? void 0 : filtersData.filters.length) > 0 ? filtersData.filters : Object.values(FiltererOptions),
            sort: (_a = filtersData === null || filtersData === void 0 ? void 0 : filtersData.sort) !== null && _a !== void 0 ? _a : SorterOptions.NewestToOldest
        }
    });
    return {
        groupedActivities: activities.filter(validToShowActivity).reduce((acc, activity) => {
            const activityDate = new Date(getActivityDate(activity));
            const date = activityDate.toLocaleString('default', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            const existingDate = acc.find((item) => item.date === date);
            if (!existingDate) {
                acc.push({ date, activities: [activity] });
            }
            else {
                existingDate.activities.push(activity);
            }
            return acc;
        }, []),
        isLoading,
        hasMore,
        fetchMore
    };
}
